/**
 * O sistema mudou de endereço: bancada-sul.netlify.app → eixoautocontrol.com.br.
 *
 * O antigo continua respondendo, e de propósito. A fila do que foi lançado
 * sem internet (localStorage) e a de fotos do checklist (IndexedDB) ficam
 * guardadas por ENDEREÇO. Um redirecionamento no Netlify mandaria todo mundo
 * para o novo na hora — e o que estivesse pendente num celular ficaria preso
 * no antigo, sem erro, para sempre.
 *
 * Então quem decide é o próprio aparelho, ao abrir: filas zeradas, muda;
 * alguma coisa pendente, abre no antigo, envia, e muda na próxima vez.
 *
 * Esta parte é pura de propósito — o teste roda em Node, sem navegador
 * (scripts/testar_endereco.mjs).
 */
export const ENDERECO_ANTIGO = "bancada-sul.netlify.app";
export const ENDERECO_NOVO = "https://eixoautocontrol.com.br";

/** Para onde ir agora, ou null para ficar onde está. */
export function destinoDaMudanca(host: string, pendentes: number): string | null {
  if (host !== ENDERECO_ANTIGO) return null;
  // Só zero de verdade libera. NaN de uma contagem que falhou não é zero.
  if (pendentes !== 0) return null;
  // `mudou` faz o login do endereço novo explicar o que aconteceu.
  return `${ENDERECO_NOVO}/?mudou=1`;
}
